<template>
    <div class="login-box">
        <div class="login-logo">
            <a href="/"><b>ABFT</b> Intranet v2</a>
        </div><!-- /.login-logo -->
        <div class="login-box-body overlay-wrapper">
            <div class="overlay" v-if="loggingIn">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
            <!--@if (isset($errors) && count($errors) > 0)-->
            <div class="alert alert-danger" v-if="error">
                <strong>Whoops!</strong> Une erreur s'est glissée dans le formulaire<br><br>
                <ul>
                    <!--@foreach ($errors->all() as $error)-->
                    <li>{{ error }}</li>
                    <!--@endforeach-->
                </ul>
            </div>
            <!--@endif-->

            <p class="login-box-msg">Identifiez-vous ! </p>

            <form method="POST" role="form" @submit.prevent="sendLoginForm">
                <input type="hidden" name="_token" value="">

                <div class="form-group has-feedback">
                    <input
                            name="username"
                            autocomplete="email"
                            data-id="login.username"
                            class="form-control js-login__username"
                            placeholder="E-mail"
                            v-model="credentials.username"
                    >
                    <span class="glyphicon glyphicon-user form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                    <input
                            name="password"
                            autocomplete="password"
                            type="password"
                            class="form-control js-login__password "
                            placeholder="Mot de passe"
                            v-model="credentials.password"
                    >
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div class="row">
                    <div class="col-xs-8">
                        <!--<div class="checkbox icheck">-->
                        <!--<label>-->
                        <!--<input name="remember" type="checkbox"> Se souvenir de moi ?-->
                        <!--</label>-->
                        <!--</div>-->

                    </div><!-- /.col -->
                    <div class="col-xs-4">
                        <button type="submit" data-id="login.submit"
                                class="btn btn-primary btn-block btn-flat">S'identifier
                        </button>
                    </div><!-- /.col -->
                    <!--<div class="col-xs-12">-->
                    <!--<div class="checkbox icheck">-->
                    <!--<a class="btn btn-link" href="{{ url('/password/reset') }}">Mot de passe oublié?</a>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </form>

        </div><!-- /.login-box-body -->
    </div><!-- /.login-box -->
</template>

<script type="text/babel">
    export default {
        data() {
            return {
                credentials: {
                    username: process.env.NODE_ENV == 'development' ? process.env.ENV_LOGIN : '',
                    password: process.env.NODE_ENV == 'development' ? process.env.ENV_PASS : ''
                },
                loggingIn: false,
                error: ''
            }
        },
        methods: {
            sendLoginForm: function () {
                this.loggingIn = true
                const credentials = {
                    username: this.credentials.username,
                    password: this.credentials.password
                }
                // Auth.login() returns a promise. A redirect will happen on success.
                // For errors, use .then() to capture the response to output
                // error_description (if exists) as shown below:
                this.$auth.login(credentials, 'Dashboard').then((response) => {
                    this.loggingIn = false
                    this.error = response.body
                })
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-box {
        position: relative
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue